import React from 'react';
import { RuleSet } from 'styled-components';
import { prettyNumber } from '../../../utils/helpers';
import { InfoViewsContainer, InfoViewsText } from './styled';
import { Icon } from '../../Icon';
import ViewsIcon from '../../../public/static/images/residences/views.svg';

interface InfoViewsProps {
  hits?: number | null;
  styles?: RuleSet<object>;
}

export const InfoViews: React.FC<InfoViewsProps> = ({ hits, styles }) => {
  const prettyViews = prettyNumber(hits);

  return (
    <InfoViewsContainer data-cy="gallery__info-views" $styles={styles}>
      <Icon indent={false} IconComponent={ViewsIcon} width={16} height={9} />
      <InfoViewsText tag="caption_1_new">{prettyViews}</InfoViewsText>
    </InfoViewsContainer>
  );
};
